module.exports = __webpack_public_path__ + "static/media/ao.2490f4bd.svg";